import { Reveal, ChapterLabel } from "./Motion";
import { HEARD_PLUS } from "../../data/content";

export const HeardPlus = () => (
  <section id="heard-plus" className="bg-cream py-24 sm:py-36">
    <div className="mx-auto max-w-[1400px] px-6 sm:px-10">
      <Reveal className="max-w-2xl">
        <ChapterLabel index="Coming Soon" />
        <h2 className="serif-display mt-8 text-[2rem] sm:text-[2.7rem] lg:text-[3.3rem] font-light text-charcoal leading-[1.1]">
          Deeper support, with <span className="italic text-sage-deep">HEARD+</span>
        </h2>
        <p className="mt-6 text-lg font-light leading-relaxed text-ink/65">
          Gentle premium tools to help you reflect, notice, and grow — arriving as HEARD blooms.
        </p>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-7">
        {HEARD_PLUS.map((f, i) => (
          <Reveal key={f.title} delay={(i % 3) * 0.07}>
            <div className="group relative h-full rounded-[1.4rem] border border-line bg-white/70 p-7 sm:p-8 transition-all duration-500 hover:-translate-y-1 hover:bg-white hover:shadow-[0_18px_44px_rgba(47,75,57,0.1)]">
              <span className="absolute right-5 top-5 rounded-full border border-sage/25 bg-sage/10 px-3 py-1 text-[0.6rem] font-medium uppercase tracking-[0.18em] text-sage-deep">HEARD+</span>
              <span className="flex h-12 w-12 items-center justify-center rounded-full bg-sage/12 text-sage">
                <f.icon size={22} strokeWidth={1.7} />
              </span>
              <h3 className="mt-6 font-serif text-2xl font-semibold text-heading">{f.title}</h3>
              <p className="mt-2.5 text-base sm:text-sm leading-relaxed text-ink/70">{f.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
